var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.sessionsChatAgent
    ? _c(
        "v-card",
        { staticClass: "listeAllChatsAgent" },
        [
          _c(
            "v-toolbar",
            { staticClass: "accent", attrs: { dark: "", dense: "" } },
            [
              _c("v-toolbar-title", [
                _vm._v(_vm._s(_vm.$t("listOfDiscussions")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "text-xs-center" },
                [
                  _c("v-progress-circular", {
                    staticClass: "primary--text",
                    attrs: { indeterminate: "", size: 100, width: 1 }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [{ name: "bar", rawName: "v-bar" }],
              staticClass: "ContentListChats"
            },
            [
              _c(
                "v-list",
                { staticClass: "listeChatsAgents" },
                [
                  _vm._l(_vm.sessionsChatAgent, function(item, i) {
                    return [
                      _c(
                        "v-list-tile",
                        {
                          key: i,
                          class: {
                            "grey lighten-5": _vm.chatSelected == item[0]
                          },
                          attrs: { ripple: "" }
                        },
                        [
                          _c("div", {
                            staticClass: "statusVisiteur",
                            class: item[5]
                          }),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$tc("visitors", 1, { count: "" }) +
                                      " " +
                                      item[0]
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.update(item)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b8d4fde", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b8d4fde","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzListChatsAgent.vue
// module id = null
// module chunks = 